import React from 'react';
import config from './config';
import Page from './page';
import { gtag, install } from 'ga-gtag';

function App() {
    install(config.gTagId);

    gtag('config', config.gTagId);
    const script = document.createElement('script');
    script.src = config.bankopen.paymenturl;
    script.async = true;
    document.body.appendChild(script);

    return <Page />;
}

export default App;
